import "./loginBox.scss";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "spot-component-library/src/components/basic/spinner/Spinner";
import { useTenant } from "../../contexts/TenantContext";
import balanceServices from "../../services/BalanceServices";
import loginService from "../../services/LoginService";
import { Tenant } from "../../services/TenantService/TenantService";
import { BalanceResponse } from "../../types/BalanceResponse";
import { LoginBoxLoggedIn } from "./LoginBoxLoggedIn";
import { LoginBoxNotLoggedIn } from "./LoginBoxNotLoggedIn";
import logoPaymentBE from "../../../resources/images/payment_logo_BE.svg";
import logoPaymentCH from "../../../resources/images/payment_logo_CH.svg";
import logoPaymentES from "../../../resources/images/payment_logo_ES.svg";
import logoPaymentFR from "../../../resources/images/payment_logo_FR.svg";
import logoPaymentDE from "../../../resources/images/payment_logo_DE.svg";
import { TenantName } from "../../types/TenantName";

export interface LoginBoxProp {
    buttonLinkUrl: string;
}

export const LoginBox = ({ buttonLinkUrl }: LoginBoxProp) => {
    const { t } = useTranslation();
    const tenant = useTenant();
    const [debtNumber, setDebtNumber] = useState<string>("");
    const [balanceResponse, setBalanaceResponse] = useState<BalanceResponse>(new BalanceResponse());
    const [isPageLoaded, setIsPageLoaded] = React.useState<boolean>(false);
    const paymentLogo = getPaymentLogo(tenant?.name);

    useEffect(() => {
        loginService.getDebtNumber().then((response) => {
            if (response) {
                setDebtNumber(response);
                setIsPageLoaded(true);
            } else {
                setIsPageLoaded(true);
            }
        });
    }, []);

    const deleteDebtNoCookie = () => {
        loginService.logout();
        setDebtNumber("");
        setIsPageLoaded(true);
    };

    useEffect(() => {
        window.addEventListener("loginSuccessful", handleLoginSuccessful, false);
        return () => {
            window.removeEventListener("loginSuccessful", handleLoginSuccessful);
        };
    }, []);

    useEffect(() => {
        if (tenant && debtNumber) {
            setIsPageLoaded(false);
            updateBalance(tenant, debtNumber);
        }
    }, [debtNumber]);

    const updateBalance = async (tenant: Tenant, debtNo: string) => {
        if (debtNumber) {
            try {
                const balanceResponse = await balanceServices.getBalance(tenant.name, debtNo);
                setBalanaceResponse(balanceResponse);
            } catch (e) {
                const error = e as Error;
                console.log("Error: " + error.message);
            }

            setIsPageLoaded(true);
        }
    };

    function handleLoginSuccessful(e: Event) {
        const loginEvent = e as CustomEvent<{ debtId: string }>;
        setDebtNumber(loginEvent.detail.debtId);
        window.location.href = buttonLinkUrl;
    }

    return (
        <div className="loginBox">
            {isPageLoaded && (
                <>
                    {debtNumber ? (
                        <LoginBoxLoggedIn debtNumber={debtNumber} balanceResponse={balanceResponse} buttonLinkUrl={buttonLinkUrl} onLogout={deleteDebtNoCookie} />
                    ) : (
                        <LoginBoxNotLoggedIn />
                    )}

                    <div className="paymentLogos">
                        <img src={paymentLogo} alt={t("LOGIN_BOX.LOGIN.PAYMENT_LOGOS_ALT")} />
                    </div>
                </>
            )}
            <Spinner isLoading={!isPageLoaded} type="page" color={"grey"} />
        </div>
    );
};

export function getPaymentLogo(tenant: TenantName | undefined) {
    switch (tenant) {
        case "be-eos":
            return logoPaymentBE;
            break;
        case "ch-eos":
            return logoPaymentCH;
            break;
        case "de-did":
            return logoPaymentDE;
            break;
        case "es-eos":
            return logoPaymentES;
            break;
        case "fr-eos":
            return logoPaymentFR;
            break;
        default:
            return logoPaymentFR;
            break;
    }
}
